import React, { useState } from "react";
import MyDataTable from "../../component/MyDataTable";
import { openSignUrl } from "../../utils/HelperFunction";
import { Link } from "react-router-dom";
import httpRequest from "../../utils/Http";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const TobeMslReceiveReverseParts = ({ reloadList, setReload }) => {
  let loggedInUser = useSelector((state) => state.authReducer.currentUser);
  const [formData, setFormData] = useState({
    partner_id: loggedInUser.entity_id,
  });
  const [formErrors, setFormErrors] = useState({});
  const [formOpen, setFormOpen] = useState(false);

  const handleClick = (row, action) => {
    setFormData({
      ...formData,
      msl_id: row.msl_id,
      msl_pid: row.id,
      action: action,
    });

    setFormOpen(true);
  };

  // Columns for the data table
  const columns = [
    {
      name: "SNo.",
      selector: (row, index) => index + 1,
    },
    {
      name: <div className="word-wrap">Warehouse</div>,
      selector: (row) => row.sender_warehouse.display_name,
      wrap: true,
    },
    {
      name: <div className="word-wrap">From Gst Number</div>,
      selector: (row) => row.msl_from_gst_details.gst_number,
      wrap: true,
    },
    {
      name: <div className="word-wrap">To Gst Number</div>,
      selector: (row) => row.msl_to_gst_details.gst_number,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Msl</div>,
      selector: (row) => row.msl_id,
      cell: (row) => (
        <Link
          to={"javascript:void(0)"}
          onClick={() => openSignUrl(row.main_file)}
        >
          {row.msl_id}
        </Link>
      ),
      wrap: true,
    },
    {
      name: <div className="word-wrap">Msl Date</div>,
      selector: (row) => new Date(row.msl_date).toDateString(),
      wrap: true,
    },
    {
      name: <div className="word-wrap">Quantity</div>,
      selector: (row) => row.quantity,
      wrap: true,
    },
    {
      name: "Basic Amount",
      selector: (row) => row.taxable_value,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Gst Amount</div>,
      selector: (row) => row.gst_amount,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Challan/Invoice</div>,
      selector: (row) => (Number(row.is_invoice) === 1 ? "Invoice" : "Challan"),
      wrap: true,
    },
    {
      name: <div className="word-wrap">Courier Name/ AWB Number</div>,
      selector: (row) =>
        `${row.courier_shippment?.courier_name} / ${row.courier_shippment?.awb_number}`,
      cell: (row) =>
        row.courier_shippment?.courier_file ? (
          <Link
            to={"javascript:void(0)"}
            onClick={() => openSignUrl(row.courier_shippment?.courier_file)}
          >
            {`${row.courier_shippment?.courier_name} / ${row.courier_shippment?.awb_number}`}
          </Link>
        ) : (
          `${row.courier_shippment?.courier_name} / ${row.courier_shippment?.awb_number}`
        ),
      wrap: true,
    },
    // {
    //   name: <div className="word-wrap">Reject</div>,
    //   cell: (row) => (
    //     <button
    //       className="btn btn-danger"
    //       onClick={(e) => {
    //         handleClick(row, "reject");
    //       }}
    //     >
    //       Reject
    //     </button>
    //   ),
    //   ignoreRowClick: true,
    //   allowOverflow: true,
    //   button: true,
    //   exportXlsx: false,
    // },
    {
      name: <div className="word-wrap">Receive</div>,
      cell: (row) => (
        <button
          className="booking-table-action-btn booking-table-action-btn--success"
          onClick={() => handleClick(row, "receive")}
        >
          <i className="fa fa-check" aria-hidden="true"></i>
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },
  ].filter(Boolean);

  const conditionalRowStyles = [
    {
      when: (row) => row.rejection_date_for_sf,
      style: {
        color: "red",
        "&:hover": {
          cursor: "pointer",
        },
      },
    },
  ];

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    if (formData.remarks?.trim().length === 0) {
      setFormErrors({ remarks: "Remarks is required" });
      return;
    }

    if (!formData.action) {
      toast.error("Action is required");
      return;
    }

    if (!formData.id) {
      toast.error("Msl Id is required");
      return;
    }

    (async () => {
      const data = await httpRequest(
        formData.action === "reject"
          ? "rejectokmslbypartner"
          : "approveokmslbypartner",
        formData,
        "POST",
      );

      if (data.status === true && data.message) {
        toast.success(data.message);
        setReload(true);
        setFormData({ partner_id: formData.partner_id });
        setFormOpen(false);
      } else {
        toast.error(data.message);
      }
    })();
  };

  const formOpenModel = () => {
    return (
      <>
        <div className="form-overlay">
          <div className="form-container" style={{ maxWidth: "500px" }}>
            <div className="form-content">
              <form id="courierupdate" onSubmit={onSubmitHandler}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card" style={{ marginBottom: "0px" }}>
                      <div className="card-header">
                        <h3 className="card-title">
                          {formData.action === "reject"
                            ? "Reject MSL"
                            : "Receive MSL"}
                        </h3>
                        <button
                          className="btn btn-sm btn-dark"
                          onClick={() => {
                            setFormData({ partner_id: formData.partner_id });
                            setFormOpen(false);
                          }}
                          style={{ float: "right" }}
                        >
                          X
                        </button>
                      </div>

                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>
                                Remarks *{" "}
                                <span style={{ color: "red" }}>
                                  {formErrors.remarks}
                                </span>
                              </label>
                              <textarea
                                type="text"
                                name="remarks"
                                className="form-control"
                                value={formData.remarks}
                                placeholder="Enter Remarks"
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    remarks: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="card-footer text-center"
                        style={{
                          marginBottom: "60px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <button
                          type="submit"
                          id="submit"
                          className="btn btn-primary col-md-12"
                          style={{ marginLeft: "0px" }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div>
      {formData?.partner_id && (
        <>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <MyDataTable
                    reloadList={reloadList}
                    columns={columns}
                    getDataListURL={`getreverchallantobedispatchfromwhTopartner?`}
                    setReload={setReload}
                    exportName={"sparelist"}
                    conditionalRowStyles={conditionalRowStyles}
                  />
                </div>
              </div>
            </div>
            {formOpen && formOpenModel()}
          </section>
        </>
      )}
    </div>
  );
};

export default TobeMslReceiveReverseParts;
